import { complement, either, isNil, isEmpty } from 'ramda'
import { parseISO, differenceInDays } from 'date-fns'
import useBootstrapData from './useBootstrapData'

const isTruthy = complement(either(isNil, isEmpty))

export default function useMostRecentFutureBooking() {
  const { mostRecentBooking } = useBootstrapData()
  const mostRecentFutureBooking = isTruthy(mostRecentBooking?.future)
    ? mostRecentBooking?.future
    : null

  const startDate = parseISO(
    mostRecentBooking?.future?.travelStartDateTime ?? ''
  )

  const isWithin7Days = startDate && differenceInDays(startDate, new Date()) < 7

  return {
    mostRecentFutureBooking,
    isWithin7Days
  }
}
